import PropTypes from "prop-types";
import { m } from "framer-motion";
import { alpha, styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import Logo from "./Logo";
import { useState, useEffect } from "react";

const RootStyle = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  right: 0,
  width: "calc(100% - 240px)", // Subtract sidebar width
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#FFFFFF",
  zIndex: 9999,
  [theme.breakpoints.down("sm")]: {
    width: "100%", // Full width on mobile
  },
}));

const LoadingContent = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

const TextWrapper = styled(Typography)(({ theme }) => ({
  color: "#01b0f1",
  fontSize: "24px",
  fontWeight: 500,
  marginLeft: "8px",
  minWidth: "120px",
}));

ContentLoadingScreen.propTypes = {
  isDashboard: PropTypes.bool,
};

export default function ContentLoadingScreen({ isDashboard, ...other }) {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev >= 3 ? 0 : prev + 1));
    }, 400);

    return () => clearInterval(interval);
  }, []);

  const dots = ".".repeat(dotCount);

  return (
    <RootStyle {...other}>
      <LoadingContent>
        <Box
          component={m.div}
          animate={{
            rotate: 360,
          }}
          transition={{
            duration: 2,
            ease: "linear",
            repeat: Infinity,
          }}
        >
          <Logo disabledLink sx={{ width: 48, height: 48 }} />
        </Box>
        <TextWrapper>Loading {dots}</TextWrapper>
      </LoadingContent>
    </RootStyle>
  );
} 